import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User adjusted the date range on the creative performance page',
  name: 'creative_performance_date_range_adjusted',
};

export default META;
